import { useTranslation } from "react-i18next";
import { Alert } from "@myphx-engineering/phx-design-system";
import { jsx } from "react/jsx-runtime";

//#region src/components/MaintenanceBanner.tsx
/**
* MaintenanceBanner component displays a maintenance alert banner
* with built-in translations for English and Spanish
*
* Note: The app must load the 'maintenance' namespace for translations to work.
*
* @example
* ```tsx
* const maintenanceStatus = useMaintenanceStatus(maintenanceWindow);
*
* <MaintenanceBanner maintenanceStatus={maintenanceStatus} />
* ```
*/
const MaintenanceBanner = ({ maintenanceStatus }) => {
	const { t } = useTranslation("maintenance");
	const { showBanner, isMaintenanceActive, timeFrame, timeFrameStatus, displaySameDate } = maintenanceStatus;
	if (!showBanner) return null;
	const { start, end } = timeFrame || {
		start: null,
		end: null
	};
	if (timeFrameStatus === "past" || timeFrameStatus === "invalid" || !start || !end) return /* @__PURE__ */ jsx(Alert, {
		severity: "warning",
		children: t("banner.withoutWindow")
	});
	let maintenanceAlertMessage;
	if (isMaintenanceActive) maintenanceAlertMessage = displaySameDate ? t("banner.withinWindow.sameDates", { displaySameDate }) : t("banner.withinWindow.differentDates", {
		start,
		end
	});
	else maintenanceAlertMessage = displaySameDate ? t("banner.outsideOfWindow.sameDates", { displaySameDate }) : t("banner.outsideOfWindow.differentDates", {
		start,
		end
	});
	return /* @__PURE__ */ jsx(Alert, {
		severity: isMaintenanceActive ? "warning" : "info",
		children: maintenanceAlertMessage
	});
};

//#endregion
export { MaintenanceBanner };